import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as SparkleIcon } from './sparkle.svg';

export const Sparkle = IconHOC(SparkleIcon);
